import { UseQueryOptions, useInfiniteQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { MarketInfo, MarketInfoV2, api } from '@/apis';

import { useCoreQuery } from '../core';
import { keys } from '../keys';

export const useMarketQuery = (
  username: string,
  options?: UseQueryOptions<MarketInfo, AxiosError>,
) =>
  useCoreQuery(
    keys.market.get(username),
    () => api.market.getMarket(username).then((res) => res),
    options,
  );

export const useMarketV2Query = (
  username: string,
  options?: UseQueryOptions<MarketInfoV2, AxiosError>,
) =>
  useCoreQuery(
    keys.market.getV2(username),
    () => api.market.getMarketV2(username).then((res) => res),
    options,
  );

export const useMarketCampaignsQuery = (
  username: string,
  category: string,
  isIntersecting: boolean,
) => {
  return useInfiniteQuery(
    keys.market.getCampaigns(username, category),
    async ({ pageParam = 1 }) => {
      const data = await api.market.getMarketCampaigns(username, pageParam, category);
      return data;
    },
    {
      getNextPageParam: (lastPage) => {
        if (lastPage.current_page === lastPage.total_page) {
          return undefined;
        }
        return lastPage.current_page + 1;
      },
      enabled: isIntersecting,
    },
  );
};

export const useMarketCampaignsV2Query = (
  username: string,
  category: string,
  isIntersecting: boolean,
) => {
  return useInfiniteQuery(
    keys.market.getV2Campaigns(username, category),
    async ({ pageParam = 1 }) => {
      const data = await api.market.getMarketCampaignsV2(username, pageParam, category);
      return data;
    },
    {
      getNextPageParam: (lastPage) => {
        if (lastPage.current_page === lastPage.total_page) {
          return undefined;
        }
        return lastPage.current_page + 1;
      },
      enabled: isIntersecting,
    },
  );
};
